import React, { useEffect, useState } from "react";
import { AdminCreateBrand, AdminViewSingleCategory } from "../utils/Api/ApiCalls";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import Swal from "sweetalert2";

const BrandForm = () => {
	const currentUser = useRecoilValue(userState);
	const [previewImageUrl, setPreviewImageUrl] = useState("");
	const [load, setLoad] = useState(false);
	const [allCartegory, setAllCartegory] = useState([]);
	const [formData, setFormData] = useState({
		name: "",
		description: "",
		category: "",
		images: null,
	});
	const OnHandleChange = (e) => {
		const { name, value, type, files } = e.target;
		if (type === "file") {
			const avatarFile = files[0];
			const url = URL.createObjectURL(avatarFile);
			setPreviewImageUrl(url);

			setFormData((prev) => ({
				...prev,
				[name]: avatarFile,
			}));
		} else {
			setFormData((prevProfile) => ({
				...prevProfile,
				[name]: value,
			}));
		}
	};

	const ViewAllCartegory = async () => {
		try {
			const response = await AdminViewSingleCategory(currentUser?.data?.info?.id);
			setAllCartegory(response.data);
			
		} catch (err) {
			return err;
		}
	};
	useEffect(() => {
		ViewAllCartegory();
	}, []);

	const UploadBrands = async () => {
		setLoad(true)
		try {
			if (
				formData.name !== "" &&
				formData.category !== "" &&
				formData.description !== "" &&
				formData.images !== null
			) {
				const response = await AdminCreateBrand(
					currentUser.data.info.id,
					formData,
				);
                setLoad(false)

				Swal.fire({
					title: "Brand Created Successfully",
					icon: "success",
				}).then(() => {
					window.location.reload();
				});
			} else {
				Swal.fire({
					title: "All field is required",
					icon: "warning",
				});
				setLoad(false)
			}
		} catch (err) {
			setLoad(false)
			return err;
		}
	};

	return (
		<div>
			<section class='content-main'>
				<div class='row'>
					<div class='col-9'>
						<div class='content-header'>
							<h2 class='content-title'>Add New Brand</h2>
							<div>
								<button class='btn btn-light rounded font-sm mr-5 text-body hover-up'>
									Save to draft
								</button>

								{load ? (
									<button
									disabled
										class='btn btn-md rounded font-sm hover-up'>
										Loading...
									</button>
								) : (
									<button
										onClick={UploadBrands}
										class='btn btn-md rounded font-sm hover-up'>
										Publish
									</button>
								)}
							</div>
						</div>
					</div>
					<div class='col-lg-6'>
						<div class='card mb-4'>
							<div class='card-header'>
								<h4>Basic</h4>
							</div>
							<div class='card-body'>
								<form>
									<div class='mb-4'>
										<label for='product_name' class='form-label'>
											Brand name <span style = {{color : 'red'}}>*</span>
										</label>
										<input
											required
											name='name'
											onChange={OnHandleChange}
											type='text'
											placeholder='Type here'
											class='form-control'
											id='product_name'
										/>
									</div>
									<div class='mb-4'>
										<label class='form-label'>Full description<span style = {{color : 'red'}}>*</span></label>
										<textarea
											required
											name='description'
											onChange={OnHandleChange}
											placeholder='Type here'
											class='form-control'
											rows='4'></textarea>
									</div>
									<div class='row'>
										<div class='col-lg-4'>
											<label class='form-label'>Category<span style = {{color : 'red'}}>*</span></label>
											<select
												required
												name='category'
												onChange={OnHandleChange}
												class='form-select'>
												<option>--Select--</option>

												{allCartegory?.map((props) => (
													<option value={props.slug.replace("/", "")}>
														{props.slug.replace("/", "")}
													</option>
												))}
											</select>
										</div>
									</div>
								</form>
							</div>
						</div>
						{/* <!-- card end// --> */}
					</div>
					<div class='col-lg-3'>
						<div class='card mb-4'>
							<div class='card-header'>
								<h4>Media</h4>
							</div>
							<div class='card-body'>
								<div class='input-upload'>
									{previewImageUrl !== "" ? (
										<img src={previewImageUrl} alt='' />
									) : (
										<img src='assets/imgs/theme/upload.svg' alt='' />
									)}
									<input
										required
										onChange={OnHandleChange}
										name='images'
										class='form-control'
										type='file'
									/>
								</div>
							</div>
						</div>
						{/* <!-- card end// --> */}
					</div>
				</div>
			</section>
		</div>
	);
};

export default BrandForm;
